"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteBucketReplicationOutput = {
    type: "structure",
    required: [],
    members: {}
};
//# sourceMappingURL=DeleteBucketReplicationOutput.js.map